import { render, staticRenderFns } from "./studentHealthRemark.vue?vue&type=template&id=0cbdf34e"
import script from "./studentHealthRemark.vue?vue&type=script&lang=js"
export * from "./studentHealthRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports